export enum Experiments {
  SEARCH_CERTIFICATE = 'search-certificate',
}
